import { Stack, Typography } from "@mui/material";
import SavingsIcon from "@mui/icons-material/Savings";
import { ValueTile } from "Components/Shared/ValueTile/ValueTile";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Components.Affiliate.Earnings;

type Props = {
  isLoading: boolean;
  value: string;
  hint: string;
};

export const TotalEarnedTile = ({ isLoading, value, hint }: Props) => {
  const { t } = useResource();

  return (
    <ValueTile
      isLoading={isLoading}
      icon={<SavingsIcon />}
      title={t(RESOURCES.TotalEarned)}
      value={value}
      explanationHint={
        <Stack gap={4}>
          <Typography fontSize="1rem" color="text.secondary" fontWeight={400}>
            {hint}
          </Typography>
        </Stack>
      }
    />
  );
};
